<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaListasPrecios"
      :titulo="$t ('Listas de precios')"
      icono="mdi-timetable"
      tabla="lispre"
      :campos="['des+', 'tiecor', 'tiereg', 'red', 'tipred', 'numpasrep-', 'impmax']"
      busqueda-rapida
      :titulo-crud="$t ('lista de precios')"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatosListaPrecios"
      :formulario-datos-api-props="{ anchoMaximo: '950', sinMargenes: true }"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      @montado="montadoTablaDatos"
    >
      <template v-slot:accionesPersonalizadas="{item}">
        <v-icon small color="primary" class="mr-2" @click="probarListaPrecios (item)">mdi-eye</v-icon>
      </template>

      <!-- F O R M U L A R I O -->

      <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col class="pb-0">
                  <CampoFormularioDatos nombre-campo="des" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tiecor" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tiereg" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="red" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tipred" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="numpasrep" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="impmax" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>

                <v-col cols="12" md="8" class="pb-0">

                  <!-- L I S T A   D E   P A S O S -->

                  <div class="mt-n3 mb-2">{{ $t ('Lista de pasos') }}</div>
                  <TablaDatosAPI
                    icono="mdi-debug-step-over"
                    tabla="paslispre"
                    :campos="['dur', 'imp', 'maxdur', 'maximp']"
                    :parametros="parametros_paslispre"
                    modo-memoria
                    titulo-crud="paso"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    dense
                    @cambios="cambiosEnPasos (datosRegistro)"
                    @montado="montadoTablaDatos"
                    :evento-antes-abrir-formulario-datos="antesAbrirFormularioPaso"
                    >
                    <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
                      <CampoFormularioDatos nombre-campo="dur" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <CampoFormularioDatos nombre-campo="imp" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <v-select
                        label="Límite de repetición"
                        :items="[{value: null, text: 'Sin límite'}, {value: 1, text: 'Duración'}, {value: 2, text: 'Importe'}]"
                        v-model="datosRegistro.limrep__AUX"
                        dense                                              >
                      </v-select>
                      <CampoFormularioDatos nombre-campo="maxdur" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <CampoFormularioDatos nombre-campo="maximp" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                    </template>
                  </TablaDatosAPI>
                  <div style="height: 15px"></div>
                </v-col>
              </v-row>
            </v-container>
      </template>
    </TablaDatosAPI>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import api from '@/api'

export default {
  components: { TablaDatosAPI, CampoFormularioDatos },
  data() {
    return {
      tablasDatos: []
    }
  },
  methods: {
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    cambiosEnPasos (datosRegistroListaPrecios) {
      if (this.tablasDatos ['paslispre'].hayCambiosModoMemoria())
        this.$set (datosRegistroListaPrecios, 'ctp__AUX', true); // ctp = Cambios en Tabla de Pasos
      else
        this.$delete (datosRegistroListaPrecios, 'ctp__AUX');
    },
    despuesGuardarFormularioDatosListaPrecios (formularioDatosAPI) {
      api.loteCambiosRegistrosTablaVista ('paslispre', this.tablasDatos ['paslispre'].loteCambiosRegistros((registro) => { registro.id_lispre = formularioDatosAPI.datosRegistro ['id_lispre'] }));
    },
    antesAbrirFormularioPaso (formulario) {
      if (formulario.datosRegistro.maxdur)
        this.$set (formulario.datosRegistro, 'limrep__AUX', 1);
      else if (formulario.datosRegistro.maximp)
        this.$set (formulario.datosRegistro, 'limrep__AUX', 2);
      else
        this.$set (formulario.datosRegistro, 'limrep__AUX', null);
    }
  },
  computed: {
    parametros_paslispre() {
      return {
        idListaPrecios: { valor: this.tablasDatos['lispre'].formulario.datosRegistro ['id_lispre'] ?? 0, descripcion: '' }
      };
    },
  }
};
</script>

<style>
</style>